<template>
  <div class="row">
    <div class="col-12">
      <b-form>
        <div class="row">
          <h5 class="mb-3">Informações sobre valores</h5>
        </div>
        <div class="row justify-content-start">
          <div class="col-md-4">
            <b-form-group label="Valor do Serviço" label-for="sep_valor">
              <money class="form-control" id="sep_valor"
                     :class="{ 'is-invalid': validation.valor }"
                     v-model="localValores.sep_valor" :min="0" v-bind="money"></money>
              <div v-if="validation.valor" class="invalid-feedback">Valor do serviço</div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Deduções" label-for="sep_deducoes">
              <money class="form-control" id="sep_deducoes"
                     v-model="localValores.sep_deducoes"
                     v-bind:disabled="!verificaDeducao.ativo" :min="0" v-bind="money"></money>
              <div v-if="!verificaDeducao.ativo" class="has-feedback">Atividade não permite deduções</div>
            </b-form-group>
          </div>
          <div v-if="verificaAliquota.isMei" class="col-md-4">
            <b-form-group label="Alíquota ISS MEI %" label-for="sep_aliquotaMei">
              <input class="form-control" id="sep_aliquotaMei" v-bind:disabled="true" value="0,00%"/>
            </b-form-group>
          </div>
          <div v-else class="col-md-4">
            <b-form-group label="Alíquota ISS %" label-for="sep_aliquotaDemais">
              <money v-if="verificaAliquota.isSimples && !verificaAliquota.aliquotaZerada"
                     class="form-control" id="sep_aliquotaDemais"
                     :class="{'is-invalid': validation.aliquota}"
                     v-model="localValores.sep_aliquota" v-bind="moneyPorcent"></money>
              <money v-if="verificaAliquota.isDemaisEmpresas && !verificaAliquota.desabilitaAliquota"
                     class="form-control"
                     :class="{'is-invalid': validation.aliquota}"
                     v-model="localValores.sep_aliquota" v-bind="moneyPorcent"></money>
              <money
                  v-if="(verificaAliquota.isDemaisEmpresas && verificaAliquota.desabilitaAliquota) || verificaAliquota.aliquotaZerada"
                  class="form-control" :disabled="true"
                  v-model="localValores.sep_aliquota" v-bind="moneyPorcent"></money>
              <div v-if="validation.aliquota" class="invalid-feedback">Aliquota entre 2,00 a 5,00</div>
            </b-form-group>
          </div>
        </div>

        <div class="row justify-content-start">
          <div class="col-md-4">
            <b-form-group label="Desconto Incondicionado" label-for="sep_desconto_incondicionado">
              <money class="form-control" id="sep_desconto_incondicionado"
                     v-model="localValores.sep_desconto_incondicionado" :min="0" v-bind="money"></money>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Desconto Condicionado" label-for="sep_desconto_condicionado">
              <money class="form-control" id="sep_desconto_condicionado"
                     v-model="localValores.sep_desconto_condicionado" v-bind="money"></money>
            </b-form-group>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-md-3">
            <b-form-group label="ISS Retido?">
              <b-form-radio @change="$emit('alter-retencao', localValores.sep_iss_retido)"
                            v-bind:disabled="!verificaRetencao.ativo"
                            v-model="localValores.sep_iss_retido"
                            class="custom-radio custom-control-inline" value="S">Sim
              </b-form-radio>
              <b-form-radio @change="$emit('alter-retencao', localValores.sep_iss_retido)"
                            v-bind:disabled="!verificaRetencao.ativo"
                            v-model="localValores.sep_iss_retido"
                            class="custom-control-inline" value="N">Não
              </b-form-radio>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Responsável por Retenção?">
              <b-form-radio v-bind:disabled="true"
                            v-model="localValores.sep_responsavel_retencao"
                            class="custom-radio custom-control-inline" value="1">Tomador
              </b-form-radio>
            </b-form-group>
          </div>
        </div>

        <!-- INSS (Avulso + CNPJ) -->
        <div v-if="isAvulso && isTomadorCNPJ">
          <div class="border p-4 mb-3">
            <div class="row">
              <h5 class="mb-3">Cálculo do INSS</h5>
            </div>
            <div class="row justify-content-start">
              <div class="col-md-3">
                <b-form-group label="Base Mensal" label-for="sep_base_inss_mensal">
                  <money class="form-control" id="sep_base_inss_mensal" :disabled="true"
                         v-model="localValores.sep_base_inss_mensal" v-bind="money"></money>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="% Base INSS" label-for="sep_aliquota_base_inss">
                  <select id="sep_aliquota_base_inss" v-model="localValores.sep_aliquota_base_inss"
                          class="custom-select" type="text">
                    <option value="100">100,00%</option>
                    <option value="20">20,00%</option>
                  </select>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Base Acomulada" label-for="base_acumulado">
                  <input type="text" class="form-control" id="base_acumulado" disabled
                         v-bind:value="inssBaseAcumulado | formatNumeroBr"/>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="% Alíquota INSS" label-for="aliquota">
                  <money class="form-control" id="aliquota" :disabled="true"
                         v-model="inssAvulso.aliquota" v-bind="moneyPorcent"></money>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="INSS no Mês" label-for="valor_mensal">
                  <input type="text" class="form-control" id="valor_mensal" disabled
                         v-bind:value="inssMensal | formatNumeroBr"/>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="INSS já Retido" label-for="ja_retido">
                  <input type="text" class="form-control" id="ja_retido" disabled
                         v-bind:value="inssJaRetido | formatNumeroBr"/>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="INSS Externo" label-for="sep_inss_externo">
                  <money class="form-control" id="sep_inss_externo"
                         v-model="localValores.sep_inss_externo" v-bind="money"></money>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="INSS Nota" label-for="valor_desta">
                  <input type="text" class="form-control" disabled id="valor_desta"
                         v-bind:value="inssValorDesta | formatNumeroBr"/>
                </b-form-group>
              </div>
            </div>
          </div>

          <div class="border p-4 mb-3">
            <div class="row">
              <h5 class="mb-3">Cálculo do IRRF</h5>
            </div>
            <div class="row justify-content-start">
              <div class="col-md-3">
                <b-form-group label="IRRF já Retido" label-for="rja_retido">
                  <money class="form-control" id="rja_retido" v-model="irrfAvulso.ja_retido"
                         :disabled="true" v-bind="money"></money>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="% Base IRRF" label-for="rbase_nota_porcetagem">
                  <select id="rbase_nota_porcetagem" v-model="irrfAvulso.base_nota_porcetagem"
                          class="custom-select" type="text">
                    <option value="100">100,00%</option>
                    <option value="60">60,00%</option>
                    <option value="40">40,00%</option>
                  </select>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Qtd. Dependentes" label-for="qt_dependente">
                  <input type="number" min="0" max="99" class="form-control" id="qt_dependente"
                         v-model="irrfAvulso.qt_dependente"/>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Dedução Dependente" label-for="deducao_dependente">
                  <money class="form-control" id="deducao_dependente"
                         v-model="irrfAvulso.deducao_dependente" :disabled="true" v-bind="money"></money>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Base Cálculo IRRF" label-for="rbase_calculo_mensal">
                  <money class="form-control" id="rbase_calculo_mensal"
                         v-model="irrfAvulso.base_calculo_mensal" :disabled="true" v-bind="money"></money>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="% Alíquota IRRF" label-for="raliquota">
                  <money class="form-control" id="raliquota" v-model="irrfAvulso.aliquota"
                         :disabled="true" v-bind="money"></money>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="IRRF Bruto" label-for="bruto">
                  <money class="form-control" id="bruto" v-model="irrfAvulso.bruto"
                         :disabled="true" v-bind="money"></money>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Parcela Dedutiva" label-for="parc_dedutiva">
                  <money class="form-control" id="parc_dedutiva" v-model="irrfAvulso.parc_dedutiva"
                         :disabled="true" v-bind="money"></money>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Valor IRRF Desta" label-for="rvalor_desta">
                  <money class="form-control" id="rvalor_desta" v-model="irrfAvulso.valor_desta"
                         :disabled="true" v-bind="money"></money>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <!-- Retenções Federais -->
        <div class="row mb-2 justify-content-start">
          <div class="col-md-3">
            <b-form-group label="INSS" label-for="sep_inss">
              <money class="form-control" id="sep_inss" v-model="localValores.sep_inss"
                     :disabled="isAvulso && isTomadorCNPJ" v-bind="money"></money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="IR" label-for="sep_ir">
              <money class="form-control" id="sep_ir" v-model="localValores.sep_ir"
                     :disabled="isAvulso && isTomadorCNPJ" v-bind="money"></money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="PIS" label-for="sep_pis">
              <money class="form-control" id="sep_pis" v-model="localValores.sep_pis" v-bind="money"></money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="CSLL" label-for="sep_csll">
              <money class="form-control" id="sep_csll" v-model="localValores.sep_csll" v-bind="money"></money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="COFINS" label-for="sep_cofins">
              <money class="form-control" id="sep_cofins" v-model="localValores.sep_cofins" v-bind="money"></money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Outras" label-for="sep_outras_retencoes">
              <money class="form-control" id="sep_outras_retencoes"
                     v-model="localValores.sep_outras_retencoes" v-bind="money"></money>
            </b-form-group>
          </div>
        </div>

        <!-- IVA -->
        <div class="row">
          <h5 class="mb-3">Imposto sobre valor agregado (IVA)</h5>
        </div>
        <div class="row justify-content-start">
          <div class="col-md-3">
            <b-form-group label="Alíquota IBS %" label-for="sep_aliquota_ibs">
              <input class="form-control" id="sep_aliquota_ibs" disabled
                     v-bind:value="localValores.sep_aliquota_ibs | formatPorcentagemBr"/>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Redução IBS %" label-for="sep_aliquota_reducao_ibs">
              <input class="form-control" id="sep_aliquota_reducao_ibs" disabled
                     v-bind:value="localValores.sep_aliquota_reducao_ibs | formatPorcentagemBr"/>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="IBS Aplicado %" label-for="sep_aliquota_ibs_aplicada">
              <input class="form-control" id="sep_aliquota_ibs_aplicada" disabled
                     v-bind:value="localValores.sep_aliquota_ibs_aplicada | formatPorcentagemBr"/>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Valor IBS" label-for="sep_valor_ibs">
              <money class="form-control" id="sep_valor_ibs" :disabled="true"
                     v-model="localValores.sep_valor_ibs" v-bind="money"></money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Alíquota CBS %" label-for="sep_aliquota_cbs">
              <input class="form-control" id="sep_aliquota_cbs" disabled
                     v-bind:value="localValores.sep_aliquota_cbs | formatPorcentagemBr"/>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Redução CBS %" label-for="sep_aliquota_reducao_cbs">
              <input class="form-control" id="sep_aliquota_reducao_cbs" disabled
                     v-bind:value="localValores.sep_aliquota_reducao_cbs | formatPorcentagemBr"/>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="CBS Aplicado %" label-for="sep_aliquota_cbs_aplicada">
              <input class="form-control" id="sep_aliquota_cbs_aplicada" disabled
                     v-bind:value="localValores.sep_aliquota_cbs_aplicada | formatPorcentagemBr"/>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Valor CBS" label-for="sep_valor_cbs">
              <money class="form-control" id="sep_valor_cbs" :disabled="true"
                     v-model="localValores.sep_valor_cbs" v-bind="money"></money>
            </b-form-group>
          </div>
        </div>

        <!-- Resumo -->
        <div class="row">
          <div class="col-sm-12">
            <resumo-calculo
                :valores="localValores"
                :sep-iss="sepIss"
                :retencao-federal="retencaoFederal"
                :valor-liquido="valorLiquido"
                iva-label="IBS + CBS (Valor Simbólico)"/>
          </div>
        </div>
        <h6 v-show="valorISSNegativo" class="text-danger">Valor do ISS não pode ser negativo</h6>
        <h6 v-show="valorLiquidoNegativo" class="text-danger">Valor líquido deve ser maior que R$ 0,00</h6>
      </b-form>
    </div>
  </div>
</template>

<script>
import {Money} from 'v-money'
import ResumoCalculo from './ResumoCalculo.vue'

export default {
  name: "TabValores",
  components: {Money, ResumoCalculo},
  props: {
    valores: {type: Object, required: true},
    verificaAliquota: {type: Object, required: true},
    verificaDeducao: {type: Object, required: true},
    verificaRetencao: {type: Object, required: true},
    isAvulso: {type: Boolean, default: false},
    isTomadorCNPJ: {type: Boolean, default: false},
    sepIss: {type: Number, default: 0},
    retencaoFederal: {type: Number, default: 0},
    valorLiquido: {type: Number, default: 0},
    valorISSNegativo: {type: Boolean, default: false},
    valorLiquidoNegativo: {type: Boolean, default: false},
    inssAvulso: {type: Object, default: () => ({aliquota: 11})},
    irrfAvulso: {type: Object, default: () => ({})},
    inssBaseAcumulado: {type: Number, default: 0},
    inssMensal: {type: Number, default: 0},
    inssJaRetido: {type: Number, default: 0},
    inssValorDesta: {type: Number, default: 0},
    validation: {
      type: Object,
      default: () => ({valor: false, aliquota: false})
    },
  },
  data() {
    return {
      money: {decimal: ',', thousands: '.', prefix: 'R$ ', precision: 2, min: 0},
      moneyPorcent: {decimal: ',', thousands: '.', prefix: '', suffix: '%', precision: 2},
    };
  },
  computed: {
    localValores() {
      return this.valores;
    },
  },
};
</script>
